// Config must be first
import '_config';
// CSS
import 'intro.js/introjs.css';
import React from 'react';
import 'react-app-polyfill/ie11';
// For IE 11 support
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { JssProvider, createGenerateClassName } from 'react-jss';
import { Provider } from 'react-redux';

import store from '_config/store';

import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';

/* */
const generateClassName = createGenerateClassName();

/* */
ReactDOM.render(
  <Provider store={store}>
    <JssProvider generateClassName={generateClassName}>
      <App />
    </JssProvider>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
